<script setup>
import { onMounted, reactive, computed, ref } from "vue";
import { useRouter } from "vue-router";
import { datePipe } from "@/utils/datatimeUtils";
import { templatesApi } from "@/api";

const router = useRouter();
const isLoading = ref(false);
const isNew = ref(false);
const data = reactive({ templats: [] });
const filterKey = reactive({ searchKey: null });
const searchKey = ref("");
const del_id = reactive({ id: 0 });
const template_name = ref("");
const template_url = ref("");
const selected_template_id = ref(-1);
const filteredData = computed(() => {
  let temp = data.templats;
  if (filterKey.searchKey) {
    temp = temp.filter((row) =>
      Object.keys(row).some(
        (key) =>
          String(row[key]).toLowerCase().indexOf(filterKey.searchKey.toLowerCase()) > -1
      )
    );
  }
  return temp;
});

onMounted(async () => {
  await checkAuthorization();
  templatesApi.getAll().then(res => {
    data.templats = res?.data;
  });
});

async function checkAuthorization() {
  // 権限チェック
  try {
    const authResp = await templatesApi.check_authorization();
    console.log(authResp);
    if (authResp.message !== "ok") {
      // 認可が"ok"でない場合、エラーページへリダイレクト
      return router.push("/admin_error");
    }
  } catch (error) {
    console.error("Authorization check failed:", error);
    return router.push("/admin_error");
  }
}



const handNewTemplate = () => {
  isNew.value = true;
  selected_template_id.value = -1;
  template_name.value = "";
  template_url.value = "";
  let btn = document.getElementById("showTemplateMoalBtn");
  btn.click();
};

const handleEdit = (template) => {
  isNew.value = false;
  selected_template_id.value = template.id;
  template_name.value = template.template_name;
  template_url.value = template.template_url;
  let btn = document.getElementById("showTemplateMoalBtn");
  btn.click();
};

const handleFilter = () => {
  filterKey.searchKey = searchKey.value;
};

const restTemplate = async () => {
  const res = await templatesApi.getAll();
  data.templats = res?.data;
  handleFilter();
};

const deleteTemplate = async () => {
  try {
    await templatesApi.deleteTemplate(del_id.id);
    restTemplate();
  } catch (error) {
    console.error("Error deleting template:", error);
  }
};

const setDelId = async (id) => {
  del_id.id = id;
  let btn = document.getElementById("showMoalBtn");
  btn.click();
};

const updatetemplate = async () => {
  try {
    isLoading.value = true;
    const data = {
      url: template_url.value,
      template_name: template_name.value,
      template_id: selected_template_id.value,
    };
    await templatesApi.updateTemplate(data);
    await restTemplate();
  } catch (error) {
    console.error("Error updating template:", error);
  } finally {
    isLoading.value = false;
    let btn = document.getElementById("btnUpdateCancel");
    btn.click();
  }
};

const created_template = async () => {
  try {
    isLoading.value = true;
    const data = {
      url: template_url.value,
      template_name: template_name.value,
    };
    await templatesApi.createTemplate(data);
    restTemplate();
  } catch (error) {
    console.error("Error creating template:", error);
  } finally {
    isLoading.value = false;
    let btn = document.getElementById("btnUpdateCancel");
    btn.click();
  }
};
</script>

<template>
  <div class="container">
    <div class="row">
      <h4>{{ $t('ChatTemplateManagementView.h4') }}</h4>
    </div>
    <div class="row">
      <div class="column">
        <label for="serach-keyword">{{ $t('ChatTemplateManagementView.search_keyword') }}</label>
        <input type="text" id="search-keyword" v-model="searchKey" />
      </div>
    </div>
    <div class="row">
      <div class="column" style="text-align: right">
        <button class="btn btn-primary" @click="handNewTemplate" style="padding: 0 50px; margin: 10px;">{{
          $t('ChatTemplateManagementView.new_template') }}</button>
        <button class="btn btn-primary" @click="handleFilter" style="padding: 0 50px; margin: 10px;">{{
          $t('ChatTemplateManagementView.search') }}</button>
      </div>
    </div>

    <!-- テンプレート一覧テーブル -->
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">{{ $t('ChatTemplateManagementView.template_name') }}</th>
          <th scope="col">{{ $t('ChatTemplateManagementView.created_at') }}</th>
          <th scope="col">{{ $t('ChatTemplateManagementView.modified_at') }}</th>
          <th scope="col">{{ $t('ChatTemplateManagementView.operation') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="template in filteredData" :key="template.id">
          <td @click="handleEdit(template)">{{ template.template_name }}</td>
          <td @click="handleEdit(template)">{{ datePipe(template.created_at) }}</td>
          <td @click="handleEdit(template)">{{ datePipe(template.modified_at) }}</td>
          <td>
            <button class="btn btn-danger btn-sm" @click="setDelId(template.id)">
              {{ $t('ChatTemplateManagementView.delete') }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- テンプレート更新modal -->
  <button id="showTemplateMoalBtn" data-bs-toggle="modal" data-bs-target="#uplodeTemplate"
    style="display:none;"></button>
  <div class="modal fade" id="uplodeTemplate" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ $t('ChatTemplateManagementView.update_template_title') }}
          </h5>
          <button type="button" class="btn-close" id="btnUpdateCancel" data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <label for="template_name" class="form-label">{{ $t('ChatTemplateManagementView.template_name') }}：</label>
          <div class="input-group mb-3">
            <input type="text" class="form-control shadow-sm" id="template_name" v-model="template_name">
          </div>
          <label for="template_url" class="form-label">{{ $t('ChatTemplateManagementView.template_url') }}：</label>
          <div class="input-group mb-3">
            <input type="text" class="form-control shadow-sm" id="template_url" v-model="template_url">
          </div>
        </div>
        <div class="modal-footer">
          <div v-if="isLoading">
            <button class="btn btn-primary" type="button" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
            </button>
          </div>
          <div v-else>
            <button type="button" class="btn btn-primary" v-if="isNew" @click="created_template">
              {{ $t('ChatTemplateManagementView.new_template') }}
            </button>
            <button type="button" class="btn btn-primary" v-else @click="updatetemplate">
              {{ $t('ChatTemplateManagementView.update') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- チャット削除警告modal -->
  <button id="showMoalBtn" data-bs-toggle="modal" data-bs-target="#delWarning" style="display:none;"></button>
  <div class="modal fade" id="delWarning" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ $t('ChatTemplateManagementView.delete') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ $t('ChatTemplateManagementView.warning_msg_1') }}</p>
          <p>{{ $t('ChatTemplateManagementView.warning_msg_2') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{
            $t('ChatTemplateManagementView.cancel') }}</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="deleteTemplate">{{
            $t('ChatTemplateManagementView.delete') }}</button>
        </div>
      </div>
    </div>
  </div>


</template>

<style scoped>
.row {
  display: flex;
  margin: 15px 5px;
}

.column {
  flex: 1;
}
</style>
